export enum AdditionalChargeTypeEnum {
  Fuel = 1,
  Tolls,
  Cleaning,
  MaintenanceRepair,
  Other,
  SupplierIncreaseFee,
  WaitingTimeDuringMove,
  TravelPreApproved,
  EVChargingTime,
  FerryPreApproved,
  ParkingStoragePreApproved,
  DayRateHours,
  AccommodationPreApproved,
  DayRateExpenses,
  ParkingOldApp,
  PerfectJobIncentive,
  Breakdown,
  EVChargingCost,
  AdminFeeBooking,
  AdminFeeBreakdown,
  AdminFeeTravelBooking,
  OtherSupplierIncentive,
  FlightPreApproved,
  WaitingTimePickUpDelayAtSite,
  WaitingTimePickUpAwaitingCustomerSignOff,
  WaitingTimeDropOffDelayAtSite,
  WaitingTimeDropOffAwaitingCustomerSignOff,
  ContractorTopUpRetainer,
  ContractorTopUpHoliday,
  BYOIncentive,
  InductionBonus,
  GrabNationalIncentive,
  GrabRegionalIncentive,
  GrabWeeklyIncentive,
}
